import { render } from "./Register.vue?vue&type=template&id=16e32129&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=16e32129&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-16e32129"

export default script